import { render, staticRenderFns } from "./supplierOutsourceDetailsQuan.vue?vue&type=template&id=c4cd51d2"
import script from "./supplierOutsourceDetailsQuan.vue?vue&type=script&lang=js"
export * from "./supplierOutsourceDetailsQuan.vue?vue&type=script&lang=js"
import style0 from "./supplierOutsourceDetailsQuan.vue?vue&type=style&index=0&id=c4cd51d2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports